import { render, staticRenderFns } from "./ColumnOptions.vue?vue&type=template&id=e330ab8c&scoped=true"
import script from "./ColumnOptions.vue?vue&type=script&lang=ts"
export * from "./ColumnOptions.vue?vue&type=script&lang=ts"
import style0 from "./ColumnOptions.vue?vue&type=style&index=0&id=e330ab8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e330ab8c",
  null
  
)

export default component.exports